export default {
  projectName: 'gezondheidswinkel',
  customer: {
    contactCentric: false
  },
  product: {
    allAreVariants: false,
    enableAddToCartOnList: true,
    showSecondImageOnHover: false,
    useTopLevelImagesForVariants: true,
    variantType: {
      main: 'Variant',
      derivative: 'Product',
    },
    details: {
      commonConnectionTypes: ['Interesting'],
      variantConnectionTypes: ['Size', 'Color', 'Variant'],
    },
    viewableExcludeTypes: ['ProductVoucher'],
    discount: {
      matchPriceListId: true,
    },
  },
  store: {
    availableStoreExcludeIds: [1],
  },
  checkout: {
    payment: {
      provider: 'Ogone'
    }
  },
  axios: {
    urlsToCache: [
      // '/api/vm/u',
      // '/api/sp/config',
      '/api/aspos/common/config',
      '/api/aspos/webnodes/main/root'
    ]
  }
}
